var _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewpasswordsprit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.29 14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.83 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.85 11.48v-.06l-.14-.21c-.13-.18-.31-.43-.54-.73a16.42 16.42 0 0 0-2.07-2.2A12.22 12.22 0 0 0 12 5a12.22 12.22 0 0 0-8 3.25 16.42 16.42 0 0 0-2.07 2.2c-.23.3-.41.55-.54.73l-.14.21v.06L.83 12l.32.54v.06l.14.21c.13.18.31.43.54.73A16.42 16.42 0 0 0 4 15.75 12.22 12.22 0 0 0 12 19a12.22 12.22 0 0 0 8.05-3.25 16.42 16.42 0 0 0 2.07-2.2c.23-.3.41-.55.54-.73l.14-.21v-.06l.32-.52zm-2.31.84a14.36 14.36 0 0 1-1.81 1.93A10.2 10.2 0 0 1 12 17a10.2 10.2 0 0 1-6.73-2.75 15.23 15.23 0 0 1-1.82-1.93L3.21 12l.24-.32a15.23 15.23 0 0 1 1.82-1.93A10.2 10.2 0 0 1 12 7a10.2 10.2 0 0 1 6.73 2.75 14.36 14.36 0 0 1 1.81 1.93c.1.12.18.22.25.32s-.15.2-.25.32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewpasswordsprit);
export default __webpack_public_path__ + "static/media/viewpasswordsprit.2075a2596867708438b8a1fb5a8438e9.svg";
export { ForwardRef as ReactComponent };